(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// ES6 modules
var $e48a5ff8b2c99cd0$exports = {};
!function(e, t) {
    $e48a5ff8b2c99cd0$exports = t();
}($e48a5ff8b2c99cd0$exports, function() {
    return (()=>{
        "use strict";
        var e = {
            d: (t, n)=>{
                for(var r in n)e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
                    enumerable: !0,
                    get: n[r]
                });
            },
            o: (e, t)=>Object.prototype.hasOwnProperty.call(e, t)
        }, t = {};
        function n(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), n.push.apply(n, r);
            }
            return n;
        }
        function r(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? n(Object(r), !0).forEach(function(t) {
                    o(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function o(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        e.d(t, {
            default: ()=>j
        });
        var a = "Sal was not initialised! Probably it is used in SSR.", s = "Your browser does not support IntersectionObserver!\nGet a polyfill from here:\nhttps://github.com/w3c/IntersectionObserver/tree/master/polyfill", i = {
            root: null,
            rootMargin: "0% 50%",
            threshold: .5,
            animateClassName: "sal-animate",
            disabledClassName: "sal-disabled",
            enterEventName: "sal:in",
            exitEventName: "sal:out",
            selector: "[data-sal]",
            once: !0,
            disabled: !1
        }, l = [], c = null, u = function(e) {
            e && e !== i && (i = r(r({}, i), e));
        }, d = function(e) {
            e.classList.remove(i.animateClassName);
        }, f = function(e, t) {
            var n = new CustomEvent(e, {
                bubbles: !0,
                detail: t
            });
            t.target.dispatchEvent(n);
        }, b = function() {
            document.body.classList.add(i.disabledClassName);
        }, p = function() {
            c.disconnect(), c = null;
        }, m = function() {
            return i.disabled || "function" == typeof i.disabled && i.disabled();
        }, v = function(e, t) {
            e.forEach(function(e) {
                var n = e.target, r = void 0 !== n.dataset.salRepeat, o = void 0 !== n.dataset.salOnce, a = r || !(o || i.once);
                e.intersectionRatio >= i.threshold ? (function(e) {
                    e.target.classList.add(i.animateClassName), f(i.enterEventName, e);
                }(e), a || t.unobserve(n)) : a && function(e) {
                    d(e.target), f(i.exitEventName, e);
                }(e);
            });
        }, y = function() {
            var e = [].filter.call(document.querySelectorAll(i.selector), function(e) {
                return !function(e) {
                    return e.classList.contains(i.animateClassName);
                }(e, i.animateClassName);
            });
            return e.forEach(function(e) {
                return c.observe(e);
            }), e;
        }, O = function() {
            b(), p();
        }, h = function() {
            document.body.classList.remove(i.disabledClassName), c = new IntersectionObserver(v, {
                root: i.root,
                rootMargin: i.rootMargin,
                threshold: i.threshold
            }), l = y();
        }, g = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            p(), Array.from(document.querySelectorAll(i.selector)).forEach(d), u(e), h();
        }, w = function() {
            var e = y();
            l.push(e);
        };
        const j = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i;
            if (u(e), "undefined" == typeof window) return console.warn(a), {
                elements: l,
                disable: O,
                enable: h,
                reset: g,
                update: w
            };
            if (!window.IntersectionObserver) throw b(), Error(s);
            return m() ? b() : h(), {
                elements: l,
                disable: O,
                enable: h,
                reset: g,
                update: w
            };
        };
        return t.default;
    })();
});


document.addEventListener("DOMContentLoaded", ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($e48a5ff8b2c99cd0$exports)))({
        once: true,
        threshold: 0.1,
        duration: 750
    }) // animations library
    ;
});
// Pobranie referencji do formularza
const $93b772d14b13910f$var$form = document.querySelector('form[name="contact"]');
// Funkcja obsługująca walidację formularza
function $93b772d14b13910f$var$validateForm(event) {
    event.preventDefault(); // Zapobiegaj domyślnej akcji przeglądarki, czyli odświeżaniu strony po wysłaniu formularza
    // Pobranie wartości pól formularza
    const firstNameInput = document.querySelector('input[name="firstName"]');
    const phoneNumberInput = document.querySelector('input[name="phoneNumber"]');
    const emailInput = document.querySelector('input[name="email"]');
    const messageInput = document.querySelector('textarea[name="message"]');
    const firstName = firstNameInput.value.trim();
    const phoneNumber = phoneNumberInput.value.trim();
    const email = emailInput.value.trim();
    const message = messageInput.value.trim();
    // Walidacja pól formularza
    if (firstName === "") {
        $93b772d14b13910f$var$displayErrorMessage(firstNameInput, "Proszę wprowadzić imię");
        return;
    } else $93b772d14b13910f$var$clearErrorMessage(firstNameInput);
    if (phoneNumber === "") {
        $93b772d14b13910f$var$displayErrorMessage(phoneNumberInput, "Proszę wprowadzić numer telefonu");
        return;
    } else if (!$93b772d14b13910f$var$validatePhoneNumber(phoneNumber)) {
        $93b772d14b13910f$var$displayErrorMessage(phoneNumberInput, "Nieprawidłowy format numeru telefonu");
        return;
    } else $93b772d14b13910f$var$clearErrorMessage(phoneNumberInput);
    if (email === "") {
        $93b772d14b13910f$var$displayErrorMessage(emailInput, "Proszę wprowadzić adres email");
        return;
    } else if (!$93b772d14b13910f$var$validateEmail(email)) {
        $93b772d14b13910f$var$displayErrorMessage(emailInput, "Nieprawidłowy format adresu email");
        return;
    } else $93b772d14b13910f$var$clearErrorMessage(emailInput);
    if (message === "") {
        $93b772d14b13910f$var$displayErrorMessage(messageInput, "Proszę wprowadzić treść wiadomości");
        return;
    } else $93b772d14b13910f$var$clearErrorMessage(messageInput);
    // Jeśli formularz jest poprawny, możesz wysłać dane gdziekolwiek chcesz
    // np. używając AJAX lub innej techniki
    // Wywołaj funkcję do wysłania formularza
    $93b772d14b13910f$var$submitForm();
}
// Funkcja pomocnicza do wyświetlania komunikatu o błędzie
function $93b772d14b13910f$var$displayErrorMessage(inputField, errorMessage) {
    const formControl = inputField.parentElement;
    const errorElement = formControl.querySelector(".error-message");
    if (!errorElement) {
        const errorDiv = document.createElement("div");
        errorDiv.classList.add("error-message");
        errorDiv.textContent = errorMessage;
        formControl.appendChild(errorDiv);
    } else errorElement.textContent = errorMessage;
}
// Funkcja pomocnicza do ukrywania komunikatu o błędzie
function $93b772d14b13910f$var$clearErrorMessage(inputField) {
    const formControl = inputField.parentElement;
    const errorElement = formControl.querySelector(".error-message");
    if (errorElement) formControl.removeChild(errorElement);
}
// Funkcja pomocnicza do sprawdzania poprawności numeru telefonu
function $93b772d14b13910f$var$validatePhoneNumber(phoneNumber) {
    const phoneRegex = /^\d{9}$/; // Ustal odpowiedni wzór dla swojego formatu numeru telefonu
    return phoneRegex.test(phoneNumber);
}
// Funkcja pomocnicza do sprawdzania poprawności adresu email
function $93b772d14b13910f$var$validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
// Funkcja do wysłania formularza
function $93b772d14b13910f$var$submitForm() {
    const formData = new FormData($93b772d14b13910f$var$form); // Utwórz obiekt FormData na podstawie formularza
    fetch("./form.php", {
        method: "POST",
        body: formData
    }).then((response)=>response.text()).then((data)=>{
        // Tutaj można dodać kod obsługujący odpowiedź serwera (np. wyświetlanie komunikatu sukcesu lub błędu)
        // Wyczyść zawartość pól formularza po wysłaniu
        document.querySelector('input[name="firstName"]').value = "";
        document.querySelector('input[name="phoneNumber"]').value = "";
        document.querySelector('input[name="email"]').value = "";
        document.querySelector('textarea[name="message"]').value = "";
        // Utwórz nowy element div dla komunikatu "Dziękujemy"
        const afterSend = document.createElement("div");
        afterSend.id = "afterSend";
        afterSend.classList.add("after-send");
        afterSend.textContent = "Dziękujemy za wysłanie wiadomości!";
        // Dodaj komunikat "Dziękujemy" do elementu nadrzędnego formularza
        $93b772d14b13910f$var$form.parentElement.appendChild(afterSend);
    }).catch((error)=>{
        // Tutaj można dodać kod obsługujący błąd żądania (np. wyświetlanie komunikatu o błędzie)
        console.error(error);
    });
}
// Nasłuchiwanie na zdarzenie submit dla formularza
$93b772d14b13910f$var$form.addEventListener("submit", $93b772d14b13910f$var$validateForm);
const $93b772d14b13910f$var$quoteWrappers = document.querySelectorAll(".quote__wrapper");
// Ustawienie klasy .active dla pierwszego .quote__wrapper
$93b772d14b13910f$var$quoteWrappers[0].classList.add("active");
let $93b772d14b13910f$var$currentIndex = 0;
function $93b772d14b13910f$var$setActiveQuote() {
    // Usunięcie klasy .active ze wszystkich .quote__wrapper
    $93b772d14b13910f$var$quoteWrappers.forEach((quoteWrapper)=>{
        quoteWrapper.classList.remove("active");
    });
    // Dodanie klasy .active do aktualnego .quote__wrapper
    $93b772d14b13910f$var$quoteWrappers[$93b772d14b13910f$var$currentIndex].classList.add("active");
    // Zwiększenie indeksu lub resetowanie go do zera, jeśli osiągnie ostatni .quote__wrapper
    $93b772d14b13910f$var$currentIndex = ($93b772d14b13910f$var$currentIndex + 1) % $93b772d14b13910f$var$quoteWrappers.length;
}
// Uruchomienie funkcji setActiveQuote co 3 sekundy (lub inny wybrany interwał czasowy)
setInterval($93b772d14b13910f$var$setActiveQuote, 5000);
const $93b772d14b13910f$var$hamburger = document.querySelector(".hamburger");
const $93b772d14b13910f$var$body = document.querySelector("body");
const $93b772d14b13910f$var$headerMenu = document.querySelector(".header__menu");
$93b772d14b13910f$var$hamburger.addEventListener("click", ()=>{
    $93b772d14b13910f$var$hamburger.classList.toggle("active");
    $93b772d14b13910f$var$headerMenu.classList.toggle("active");
    if ($93b772d14b13910f$var$headerMenu.classList.contains("active")) {
        $93b772d14b13910f$var$body.style.overflow = "hidden";
        $93b772d14b13910f$var$headerMenu.setAttribute("aria-expanded", "true");
        $93b772d14b13910f$var$headerMenu.focus();
    } else {
        $93b772d14b13910f$var$body.style.overflow = "";
        $93b772d14b13910f$var$headerMenu.setAttribute("aria-expanded", "false");
    }
});
$93b772d14b13910f$var$headerMenu.addEventListener("click", (event)=>{
    if (event.target.tagName === "A") {
        $93b772d14b13910f$var$hamburger.classList.remove("active");
        $93b772d14b13910f$var$headerMenu.classList.remove("active");
        $93b772d14b13910f$var$body.style.overflow = "";
    }
});
const $93b772d14b13910f$var$calculateHeaderHeight = ()=>{
    const header = document.querySelector("header");
    const runCalculation = ()=>{
        if (header) {
            const headerHeight = header.offsetHeight;
            document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
        }
    };
    window.addEventListener("resize", runCalculation);
    runCalculation();
};
$93b772d14b13910f$var$calculateHeaderHeight();
const $93b772d14b13910f$var$headerWrapper = document.querySelector(".header__wrapper");
window.addEventListener("scroll", ()=>{
    const scrollPosition = window.scrollY;
    if (scrollPosition > 50) $93b772d14b13910f$var$headerWrapper.classList.add("header__wrapper--full");
    else $93b772d14b13910f$var$headerWrapper.classList.remove("header__wrapper--full");
});
// Pobierz elementy o klasach tabs__tab i tabs__content
const $93b772d14b13910f$var$tabs = document.querySelectorAll(".tabs__tab");
const $93b772d14b13910f$var$contents = document.querySelectorAll(".tabs__content");
// Dodaj zdarzenie kliknięcia do każdego elementu tab
$93b772d14b13910f$var$tabs.forEach((tab, index)=>{
    tab.addEventListener("click", ()=>{
        // Usuń klasę tab__content--active ze wszystkich elementów
        $93b772d14b13910f$var$contents.forEach((content)=>{
            content.classList.remove("tabs__content--active");
        });
        // Dodaj klasę tab__content--active do odpowiedniego elementu na podstawie indeksu
        $93b772d14b13910f$var$contents[index].classList.add("tabs__content--active");
    });
});

})();
//# sourceMappingURL=index.0e51ee2b.js.map
